import React from 'react'
import { Box } from '@maui/elements'

export const Divider = (props) => (
  <Box
    backgroundColor='colorBorderDeemphasis'
    height='1px'
    marginTop='-8px'
    {...props}
  />
)
